import { $deleteFromArray, $handleError, $updateOrAdd } from '@/utils';
import apiService from '@Task/service/links.service';
// import Vue from 'vue';

export const  LINK = {
  namespaced: true,
  state: {
    entries: [],
    total: 0,
    loading: false,
    updateLoading: false,
    options: {},
  },
  getters: {
    GET_ENTRIES(state,rootState) {
      return rootState.TASK.entries.links;
    },
    GET_TOTAL(state,rootState) {
      return rootState.TASK.entries?.links?.length;
    },
    GET_LOADING(state) {
      return state.loading;
    },
    GET_UPDATE_LOADING(state) {
      return state.updateLoading;
    },

    GET_OPTIONS(state) {
      return state.options;
    },
  },
  mutations: {
    SET_ENTRIES(state, value) {
      state.entries = value;
    },
    SET_TOTAL(state, value) {
      state.total = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },

    SET_UPDATE_LOADING(state, value) {
      state.updateLoading = value;
    },

    SET_OPTIONS(state, value) {
      state.options = value;
    },
  },
  actions: {
    CLEAR({ commit }) {
      commit('SET_ENTRIES', []);
      commit('SET_TOTAL', 0);
    },
    /* eslint-disable */
    GET({ commit, state,rootState }) {
      commit('SET_LOADING', true);
         
    
      return apiService
        .get(rootState.TASK.options)
        .then((res) => {
          commit('SET_ENTRIES', res.data);
          commit('SET_TOTAL', res.data.length);
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },

    GET_BY_ID(context, id) {
      return apiService.getById(id);
    },
  
    UPDATE({ state, commit ,rootState}, data) {
      return new Promise((resolve, reject) => {
        commit('SET_UPDATE_LOADING', true);
        apiService
          .update(data)
          .then((res) => {
            $updateOrAdd(rootState.TASK.entries.links, res.data);
           // Vue.prototype.$dialog.notify.success(`Link Successfully Updated.`);
            resolve(res);
          })
          .catch((err) => {
            $handleError(err);
            reject(err);
          })
          .finally(() => {
            commit('SET_UPDATE_LOADING', false);
          });
      });
    },
    ADD({ state, commit,rootState }, data) {
      return new Promise((resolve, reject) => {
        commit('SET_UPDATE_LOADING', true);
        
        apiService
          .add(data)
          .then((res) => {
            $updateOrAdd(rootState.TASK.entries.links, res.data);
            //Vue.prototype.$dialog.notify.success(`Link  Successfully Added.`);
            commit('SET_TOTAL', ++state.total);
            resolve(res);
          })
          .catch((err) => {
            $handleError(err);
            reject(err);
          })
          .finally(() => {
            commit('SET_UPDATE_LOADING', false);
          });
      });
    },

    DELETE({ state, commit ,rootState}, id) {
      return apiService
        .del(id)
        .then(() => {
          $deleteFromArray(rootState.TASK.entries.links, id);
          commit('SET_TOTAL', --state.total);
          // Vue.prototype.$dialog.notify.success('Deleted Successfully', {
          //   position: 'top-right',
          //   timeout: 3000,
          // });
        })
        .catch((err) => {
          $handleError(err);
        });
    },
  },
};
